const fromForms = {
  'footer': 'footer',
  'resources': 'resources',
  'captador': 'captador'
}
export { fromForms }
